import { Delete, Edit } from "@mui/icons-material";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    TableCellStyle,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    designersReset,
    GetAllDesigners,
} from "../../Redux/DesignerSlice/DesignerSlice";
import { DeleteSingleLicens } from "../../Redux/DesignerSlice/LicensSlice/LicensSlice";
import BusinessForm from "../Business/BusinessForm";
import EditLicense from "./DesignerLicense/EditLicense";

const DesignerLicenseShow = ({ license }) => {
    const { isLoading } = useSelector((state) => state.designer_licens);
    const dispatch = useDispatch();

    // Delete designer License Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        toast.success(" designer license deleted success");
        await dispatch(GetAllDesigners());
        await dispatch(designersReset());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteSingleLicens(data.id));
        await CallNotificationMethod();
        await setTableId(data.id);
    };
    const handelDeleteDesignerLicense = async (data) => {
        handleOpen(data);
    };

    //edit row
    const [edit, setEdit] = useState(false);
    const handelOpenEditRow = (data) => {
        setData(data);
        setEdit(true);
    };
    const handelCloseEditRow = () => {
        setData({});
        setEdit(false);
    };

    return (
        <>
            <TableRowStyled>
                <TableCellStyle  colSpan="7">
                    <Table>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Holder Name</TableCell>
                                <TableCell>License Number</TableCell>
                                <TableCell>State</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableBody>
                            {license.map((licens, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>{index + 1}</TableCellStyle>
                                    <TableCellStyle>
                                        {licens.holder_name}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {licens.license_number}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {licens?.state?.name}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <IconButton
                                            onClick={() =>
                                                handelOpenEditRow(licens)
                                            }
                                        >
                                            <Link to="#">
                                                <Edit color="success" />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={() =>
                                                handelDeleteDesignerLicense(
                                                    licens
                                                )
                                            }
                                        >
                                            <Link to="#">
                                                <Delete color="error" />
                                            </Link>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>
                </TableCellStyle>
                {/* delete modal  */}
                <DeleteModal
                    open={open}
                    close={handleClose}
                    title={data?.holder_name}
                    onClick={DeleteRow}
                    loading={isLoading}
                />
                {/* EDIT MODAL  */}
                <PopupModal open={edit} close={handelCloseEditRow}>
                    <EditLicense data={data} />
                </PopupModal>
            </TableRowStyled>
        </>
    );
};

export default DesignerLicenseShow;
